import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCart } from "../lib/CartContext";
import { fmtMoney } from "../lib/money";
import { useAuth } from "../lib/AuthContext";
import { Trash2, ShoppingBag, ArrowRight } from "lucide-react";

export default function CartPage() {
  const { items, total, count, removeItem, clear } = useCart();
  const { user } = useAuth();
  const nav = useNavigate();

  return (
    <div className="pb-24 md:pb-12 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-6">
      <h1 className="font-display font-black text-4xl sm:text-6xl uppercase mb-6">Cart<span className="text-[#D4FF00]">.</span></h1>

      {items.length === 0 ? (
        <div className="text-center py-20">
          <ShoppingBag size={48} strokeWidth={1.5} className="mx-auto text-[#A1A1AA] mb-3"/>
          <div className="text-[#A1A1AA]">Your cart is empty.</div>
          <Link to="/" className="btn-primary mt-6 inline-block">Start shopping</Link>
        </div>
      ) : (
        <div className="grid lg:grid-cols-[1fr_360px] gap-6">
          <div className="space-y-3">
            {items.map((it, i) => (
              <div key={`${it.product_id}-${it.size || "nosize"}-${i}`} data-testid={`cart-row-${it.product_id}`} className="card flex gap-3 p-3">
                <img src={it.product?.images?.[0]} className="w-24 h-24 object-cover rounded-xl"/>
                <div className="flex-1 min-w-0">
                  <Link to={`/product/${it.product_id}`} className="font-bold line-clamp-1 hover:text-[#D4FF00]">{it.product?.name}</Link>
                  <div className="text-xs text-[#A1A1AA]">{it.product?.store_name}</div>
                  {it.size && <div className="text-xs mt-1">Size: <span className="font-bold">{it.size}</span></div>}
                  <div className="text-xs mt-1">Qty: <span className="font-bold">{it.quantity}</span></div>
                </div>
                <div className="flex flex-col items-end justify-between">
                  <div className="font-display font-black text-[#D4FF00]">{fmtMoney(it.product?.price * it.quantity)}</div>
                  <button data-testid={`cart-remove-${it.product_id}`} onClick={()=>removeItem(it.product_id, it.size)} className="text-[#A1A1AA] hover:text-[#FF007F]"><Trash2 size={16}/></button>
                </div>
              </div>
            ))}
            <button onClick={clear} className="text-xs text-[#A1A1AA] hover:text-[#FF007F]">Clear cart</button>
          </div>

          <aside className="card p-5 h-fit sticky top-24">
            <div className="font-display font-bold uppercase text-sm mb-4">Summary</div>
            <div className="flex justify-between text-sm mb-2">
              <span className="text-[#A1A1AA]">Items</span>
              <span>{count}</span>
            </div>
            <div className="flex justify-between text-sm mb-2">
              <span className="text-[#A1A1AA]">Subtotal</span>
              <span>{fmtMoney(total)}</span>
            </div>
            <div className="flex justify-between text-sm mb-4">
              <span className="text-[#A1A1AA]">Shipping</span>
              <span className="text-[#D4FF00]">FREE</span>
            </div>
            <div className="border-t border-[#3D2845] pt-4 flex justify-between font-display font-black text-xl mb-4">
              <span>Total</span>
              <span className="text-[#D4FF00]">{fmtMoney(total)}</span>
            </div>
            {user ? (
              <button data-testid="checkout-btn" onClick={()=>nav("/checkout")} className="btn-primary w-full flex items-center justify-center gap-2">
                Checkout <ArrowRight size={16}/>
              </button>
            ) : (
              <button data-testid="login-to-checkout" onClick={()=>nav("/login")} className="btn-primary w-full">
                Login to checkout
              </button>
            )}
          </aside>
        </div>
      )}
    </div>
  );
}
